export const REDIRECT_TO_URL_KEY = 'redirectTo'
